import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  CategoriesListResponse,
  Category,
  CreateCategoryInput,
  UpdateCategoryInput,
} from "@money/shared";
import { apiFetch } from "./client";

export const categoriesKey = ["categories"] as const;

export function useCategories() {
  return useQuery({
    queryKey: categoriesKey,
    queryFn: () => apiFetch<CategoriesListResponse>("/categories"),
    staleTime: 60_000,
  });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCategoryInput) =>
      apiFetch<Category>("/categories", { method: "POST", body: input }),
    onSuccess: () => qc.invalidateQueries({ queryKey: categoriesKey }),
  });
}

export function useUpdateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; patch: UpdateCategoryInput }) =>
      apiFetch<Category>(`/categories/${input.id}`, { method: "PATCH", body: input.patch }),
    onSuccess: () => qc.invalidateQueries({ queryKey: categoriesKey }),
  });
}

export function useDeleteCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiFetch<void>(`/categories/${id}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: categoriesKey }),
  });
}
